export const getChileData = () => ({
  name: "Chili",
  description: "Le Chili est un pays viticole unique, protégé par l'océan Pacifique à l'ouest et les Andes à l'est. Cette géographie exceptionnelle crée un climat méditerranéen idéal pour la viticulture, produisant des vins de qualité internationale avec une personnalité distincte.",
  type: "country",
  regions: [
    { name: "Maipo", area: "12,000 ha", percentage: "15%", description: "Vallée historique" },
    { name: "Colchagua", area: "18,000 ha", percentage: "22%", description: "Vins de qualité" },
    { name: "Curicó", area: "15,000 ha", percentage: "18%", description: "Production diversifiée" },
    { name: "Maule", area: "20,000 ha", percentage: "24%", description: "Plus grande région" },
    { name: "Casablanca", area: "5,000 ha", percentage: "6%", description: "Vins blancs" },
    { name: "Autres", area: "12,000 ha", percentage: "15%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Maipo", x: -70.5, y: -33.5, color: "#4B164C", size: 6 },
    { region: "Colchagua", x: -71.5, y: -34.5, color: "#6d2c7a", size: 7 },
    { region: "Curicó", x: -71.0, y: -35.0, color: "#8a4a8a", size: 6 },
    { region: "Maule", x: -71.5, y: -35.5, color: "#a768a6", size: 8 },
    { region: "Casablanca", x: -71.5, y: -33.0, color: "#c486c4", size: 4 }
  ],
  statistics: {
    totalArea: "82,000 ha",
    production: "10 million hectolitres",
    regions: "6 régions principales",
    appellations: "30+ appellations",
    exportPercentage: "70%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influences océaniques et andines",
    soil: "Sols alluviaux, granitiques, argileux, excellente diversité géologique",
    viticulture: "Protection naturelle contre les maladies, irrigation contrôlée"
  },
  wineStyles: {
    red: "Vins rouges structurés et fruités, avec des tanins mûrs et une excellente fraîcheur",
    white: "Vins blancs frais et aromatiques, avec une belle acidité et des notes minérales",
    rosé: "Rosés élégants et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture chilienne remonte à l'arrivée des conquistadors espagnols au XVIe siècle. Les missionnaires ont introduit les premiers cépages. Au XIXe siècle, l'immigration française a apporté de nouveaux cépages comme le Cabernet Sauvignon et le Carmenère. L'isolement géographique du Chili a permis de préserver des cépages ancestraux. Aujourd'hui, le Chili est reconnu pour ses vins de qualité et son innovation viticole.",
  foodPairing: "Cuisine chilienne traditionnelle : empanadas, ceviche, pastel de choclo, curanto. Les vins chiliens s'accordent parfaitement avec les fruits de mer, les viandes rouges et la cuisine internationale."
}); 